var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 61,
    viewBox: "0 0 81 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 46,
    height: 46,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13.5,
    r: 4,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 43.5L10 35C11.1667 33.8333 14.1 32.2 16.5 35C19.5 38.5 22 43.5 26.5 36C30.1 30 32.3333 28.8333 33 29",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 13.5H71C75.6944 13.5 79.5 17.3056 79.5 22V51C79.5 55.6944 75.6944 59.5 71 59.5H42C37.3056 59.5 33.5 55.6944 33.5 51V22C33.5 17.3056 37.3056 13.5 42 13.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9844 34.2539C69.8546 35.1675 69.8545 37.8325 67.9844 38.7461L51.8477 46.6299C50.1869 47.4412 48.2502 46.232 48.25 44.3838L48.25 28.6162C48.2502 26.768 50.1869 25.5588 51.8477 26.3701L67.9844 34.2539Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubir);
export default __webpack_public_path__ + "static/media/subir.9286249a6f98fcbceef5f6b366ca785e.svg";
export { ForwardRef as ReactComponent };